var CryptoJS = require("crypto-js");

export function aesEncrypt(text) {
  var encrypted = CryptoJS.AES.encrypt(text, process.env.REACT_APP_HEADER_KEY);

  return encrypted.toString();
}

export function aesDecrypt(text) {
  var decrypted = CryptoJS.AES.decrypt(text, process.env.REACT_APP_HEADER_KEY);

  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * Get translated content for CSV export using the same translation system as TechBaseText
 * @param {string} translationKey - The translation key in format "{{KEY}}"
 * @returns {string} - The translated text or the original key if translation fails
 */
export function getTranslatedContent(translationKey) {
  try {
    // Import the translation function from utils/index.js
    const { getSelectedLanguageContent } = require('./index');
    const translation = getSelectedLanguageContent(translationKey);
    
    // If translation returns the key itself, it means translation failed
    return translation === translationKey ? translationKey : translation;
  } catch (error) {
    console.warn(`Translation failed for key: ${translationKey}`, error);
    return translationKey;
  }
}